// extracted by mini-css-extract-plugin
module.exports = {"renewDialogContent":"styles_renewDialogContent__3NAdU","renewDialogButtons":"styles_renewDialogButtons__3iIeI"};